import { qs, qsa } from "@/utils/dom";

export function initNavbar(): void {
  initMobileToggle();
  initActiveLinkHighlight();
}

function initMobileToggle(): void {
  const toggle = qs<HTMLButtonElement>("[data-nav-toggle]");
  const menu = qs<HTMLElement>("[data-mobile-menu]");
  if (!toggle || !menu) return;

  const iconOpen = qs<SVGElement>("[data-nav-icon-open]", toggle);
  const iconClose = qs<SVGElement>("[data-nav-icon-close]", toggle);

  const setExpanded = (expanded: boolean) => {
    toggle.setAttribute("aria-expanded", String(expanded));
    menu.classList.toggle("hidden", !expanded);
    iconOpen?.classList.toggle("hidden", expanded);
    iconClose?.classList.toggle("hidden", !expanded);
  };

  toggle.addEventListener("click", () => {
    const isExpanded = toggle.getAttribute("aria-expanded") === "true";
    setExpanded(!isExpanded);
  });

  for (const link of qsa<HTMLAnchorElement>("a", menu)) {
    link.addEventListener("click", () => setExpanded(false));
  }
}

function initActiveLinkHighlight(): void {
  const links = qsa<HTMLAnchorElement>("[data-nav-link]");
  const currentPath = window.location.pathname.replace(/\/$/, "") || "/";

  for (const link of links) {
    const linkPath = new URL(link.href).pathname.replace(/\/$/, "") || "/";
    if (linkPath === currentPath) {
      link.classList.add("text-brand-700");
      link.setAttribute("aria-current", "page");
    }
  }
}
